/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {verifyEmailAddressPost, VerifyEmailVerificationTokenParams} from "../fn/email-verification/verify-token-post";
import {SendVerificationEmailParams, sendVerificationEmailPost} from "../fn/email-verification/send-email-post";

@Injectable({ providedIn: 'root' })
export class EmailVerificationService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /**
     * Verifies an email verification code, and updates the users email verification stratus if it is valid
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    validateEmailVerificationToken(params: VerifyEmailVerificationTokenParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return verifyEmailAddressPost(this.http, this.rootUrl, params, context);
    }

    /**
     * Sends an email verification link to an existing user
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    sendVerificationEmail(params: SendVerificationEmailParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return sendVerificationEmailPost(this.http, this.rootUrl, params, context);
    }
}
